import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LiveMCX = () => {
  const [metals, setMetals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = () => {
      fetch('https://easycomm.in/Rest3/metals_api')
        .then(response => response.json())
        .then(data => setMetals(data))
        .catch(error => console.error('Error:', error));
    };

    // Initial fetch
    fetchData();
    
    // Set interval for updates
    const interval = setInterval(fetchData, 2000);
    
    return () => clearInterval(interval);
  }, []);

  const handleMetalClick = (metalName) => {
    navigate('/buy/'+metalName);
  };

  const formatPrice = (price) => {
    return `${parseFloat(price).toFixed(2)}`;
  };

  return (
    <div className="container-fluid bg-light min-vh-100">
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold text-dark">LIVE MCX</h4>
          <span className="badge bg-success">
            <i className="bi bi-lightning-fill me-1"></i>
            Live
          </span>
        </div>

        {metals.length === 0 ? (
          <div className="text-center py-5">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading market data...</p>
          </div>
        ) : (
          <div className="row g-3">
            {metals.map((item, index) => {
              const change = parseFloat(item.chg);
              const isPositive = change >= 0;
              
              return (
                <div key={index} className="col-12">
                  <div 
                    className="card border-0 shadow-sm"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleMetalClick(item.metal)}
                  >
                    <div className="card-body">
                      <div className="row align-items-center">
                        {/* Left side - Metal info */}
                        <div className="col-8">
                          <div className="d-flex align-items-center">
                            <div 
                              className="rounded-circle d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: isPositive ? '#d1fae5' : '#fee2e2'
                              }}
                            >
                              <span className={`fw-bold ${isPositive ? 'text-success' : 'text-danger'}`}>
                                {item.metal.charAt(0)}
                              </span>
                            </div>
                            <div>
                              <h6 className="fw-bold mb-1">{item.metal}</h6>
                              <div className="d-flex">
                                <small className="text-danger me-3">
                                  <span className="text-muted">O: </span>{formatPrice(item.open)}
                                </small>
                                <small className="text-success me-3">
                                  <span className="text-muted">H: </span>{formatPrice(item.high)}
                                </small>
                                <small className="text-primary">
                                  <span className="text-muted">L: </span>{formatPrice(item.low)}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Right side - Price and Change */}
                        <div className="col-4 text-end">
                          <div className="mb-1">
                            <span 
                              className="p-1 text-white fw-bold"
                              style={{ backgroundColor: item.color || '#0cba6b' }}
                            >
                              {formatPrice(item.rate)}
                            </span>
                          </div>
                          <div className={`d-inline-flex align-items-center px-2 py-1 rounded ${isPositive ? 'bg-success bg-opacity-10' : 'bg-danger bg-opacity-10'}`}>
                            <i className={`bi ${isPositive ? 'bi-arrow-up' : 'bi-arrow-down'} me-1 ${isPositive ? 'text-success' : 'text-danger'}`}></i>
                            <span className={`fw-semibold ${isPositive ? 'badge text-success' : 'badge text-danger'}`}>
                              {item.chg}%
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Footer Info */}
        
      </div>
    </div>
  );
};

export default LiveMCX;